<template>
  <div class="wt2-sg -inner-header">
    <div class="-header-back">
      <wt-button
        v-if="!hideBack"
        type="transparent"
        text="Back"
        icon="wticon-angle-left"
        @click="cancel"
      />
    </div>
    <div class="-header-center">
      <slot></slot>
    </div>
    <ian-controls v-if="!hideIan" />
  </div>
</template>

<script>
import IanControls from 'AssetEditor/functionality/InAssetNavigation/IanControls.vue';
import bus from 'AssetEditor/AssetEditorEventBus';
import { mapState } from 'vuex';

export default {
  components: { IanControls },

  props: {
    hideBack: { type: Boolean, default: false },
    hideIan: { type: Boolean, default: false },
  },

  computed: {
    ...mapState('assetEditor', ['ian']),
  },

  methods: {
    cancel() {
      bus.$emit('backToPreview');
    },
  },
};
</script>

<style lang="scss" scoped>
.-inner-header {
  height: 100%;
  display: grid;
  grid-template-columns: 177px 1fr auto;
  padding-left: 20px;

  .-header-back {
    button {
      padding: 0;
      min-width: 100px;
    }
    align-self: center;
    justify-self: self-start;
  }

  .-header-center {
    overflow: auto;
  }
}
</style>
